var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYAxisgrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 2,
    viewBox: "0 0 404 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H404H0Z",
    fill: "#343A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H404",
    stroke: "#F8F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYAxisgrid);
export default __webpack_public_path__ + "static/media/Y-axis grid.bd756733bc248ec456a17845fe957aff.svg";
export { ForwardRef as ReactComponent };